<p style="text-align: center;
font-family: Roboto, sans-serif;
font-weight: 400;
font-size: 14px;
color: #58595b;">{{toolName}} Goes here </p>
